import { BASE_URL } from '@constants/api'
import { UserTokenRequest, UserTokenResponse } from '@models/userToken.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setAuthorization } from '@utils/helpers'

export const userTokenApi = createApi({
	reducerPath: 'userTokenApi',
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: (headers, ctx) => setAuthorization(headers, ctx),
	}),
	endpoints: (builder) => ({
		generateToken: builder.mutation<UserTokenResponse, UserTokenRequest>({
			query: (body) => ({
				url: '/user/generate-token',
				method: 'POST',
				body,
			}),
		}),
	}),
})

export const { useGenerateTokenMutation } = userTokenApi
